import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-standard-document',
  templateUrl: './standard-document.component.html',
  styleUrls: ['./standard-document.component.css']
})
export class StandardDocumentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
  CHEQUINGACCOUNTFORMNEW() {
    let link = document.createElement("a");
    link.download = "CHEQUING_ACCOUNT_FORM_NEW";
    link.href = "assets/img/forms/CHEQUING_ACCOUNT_FORM_NEW.pdf";
    link.click();
  }
  DECLARATIONOFSOURCEOFFUNDSFORMRevised(){
    let link = document.createElement("a");
    link.download = "DECLARATION_OF_SOURCE_OF_FUNDS_FORM-Revised";
    link.href = "assets/img/forms/DECLARATION_OF_SOURCE_OF_FUNDS_FORM-Revised.pdf";
    link.click()
  }

  GROUPMEMBERSHIPFORMSeptember13th2019(){
    let link = document.createElement("a");
    link.download = "GROUP_-_MEMBERSHIP_FORM_-_September_13th_2019";
    link.href = "assets/img/forms/GROUP_-_MEMBERSHIP_FORM_-_September_13th_2019.pdf";
    link.click()
  }
  
  NEWMEMBERAPPLICATIONFORM2FATCAAMLCFTCOMPLIANCEFINALDRAFT(){
    let link = document.createElement("a");
    link.download = "NEW_MEMBER_APPLICATION_FORM_2_FATCA_-AML-CFT_COMPLIANCE-FINAL_DRAFT";
    link.href = "assets/img/forms/NEW_MEMBER_APPLICATION_FORM_2_FATCA_-AML-CFT_COMPLIANCE-FINAL_DRAFT.pdf";
    link.click()
  }
  
  NEWMEMBERHSIPAPPLICATIONFORMBUSINESSACCOUNTS(){
    let link = document.createElement("a");
    link.download = "NEW_MEMBERHSIP_APPLICATION_FORM_-_BUSINESS_ACCOUNTS";
    link.href = "assets/img/forms/NEW_MEMBERHSIP_APPLICATION_FORM_-_BUSINESS_ACCOUNTS.pdf";
    link.click()
  }
  
  TaxResidencySelfCertificationmccu(){
    let link = document.createElement("a");
    link.download = "Tax_Residency_Self_Certification_(mccu)";
    link.href = "assets/img/forms/Tax_Residency_Self_Certification_(mccu).pdf";
    link.click()
  }
  
  W9FORM(){
    let link = document.createElement("a");
    link.download = "W-9_FORM";
    link.href = "assets/img/forms/W-9_FORM.pdf";
    link.click()
  }
  
  
}
